
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConnection2BarsCaution as ObiConnection2BarsCautionElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-connection-2-bars-caution.js';
 
 
 

 
 export const ObiConnection2BarsCaution = createComponent({
   react: React,
   tagName: 'obi-connection-2-bars-caution',
   elementClass: ObiConnection2BarsCautionElement,
   events: {
     
   }
  });
 
 